export default {
  // CurricularMeshView
  all: 'all',

  // CurricularMesh
  curricularMesh: 'Curricular Mesh',
  modality: 'Modality',
  intermediateOutput: 'Intermediate output',
  continuity: 'Continuity',
  year: 'Year',
  level: 'Level',
  semester: 'Semester',
  trimester: 'Trimester',
  bimester: 'Bimester',
  prerequisites: 'Prerequisites',
  indicatesIntermediateOutputSemester: '---------------- Indicates intermediate output semester',
  inCaseMatterHasNoFormationLine: '* In case the {matter} has no {formationLine}, it will be shown in color',
  number: 'No.',
  orderNumberOf: 'Order number of the',
  numberOf: 'No. of the',
  planLevel: 'Plan level',
  noAssociatedCompetence: 'This {matter} has no associated {competence}.',
  matterHasModalities: 'This {matter} has {count} {modality}.',
  matterWithoutModality: '{matter} without {modality}.',
  matterWithoutPrerequisites: 'This {matter} has no prerequisites.',
  noDataToShow: 'No {entity} to display.',
  profileWithoutCompetences: 'The {profile} has no {competences}.',
  optionalField: 'This field is optional.',
  total: 'Total.',

  // EgressProfileCompetenceMentionForm
  type: 'Type',
  selectType: 'Select a type',
  mention: 'Mention',
  diploma: 'Diploma',
  specialization: 'Specialization',
  certification: 'Certification',
  other: 'Other',
  specifyType: 'Specify type',
  requiredWhenOther: 'This field is required when you select "Other".',
}
